import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { getUser } from 'auth';
import { AccountFeatureGuard } from 'guard/AccountFeatureGuard';
import { asyncRouteLoader } from 'utils/asyncRouteLoader';
import RouteAnalytics from './RouteAnalytics';

const ProfileSettings = lazy(() => import('containers/ProfileSettings'));
const UserAccount = asyncRouteLoader(
  () => import('containers/UserAccount'),
  [
    {
      type: 'reducer',
      reducerKey: 'userAccount',
      importPromise: () => import('containers/UserAccount/reducer'),
    },
    {
      type: 'saga',
      importPromise: () => import('containers/UserAccount/sagas'),
    },
  ]
);
const EmailSignature = lazy(
  () => import('containers/ProfileSettings/EmailSignature')
);

const SlackConnection = lazy(
  () => import('containers/ProfileSettings/SlackConnection')
);

const isPasswordAuth = () => {
  const user = getUser();
  return user && user.authMethod === 'password';
};

const ProfileSettingsIndex = () => (
  <Navigate
    to={`${isPasswordAuth() ? 'security' : 'email-signature'}`}
    replace
  />
);

const ChangePasswordGuard = () =>
  isPasswordAuth() ? (
    <RouteAnalytics pageName="Change-Password">
      <UserAccount />
    </RouteAnalytics>
  ) : (
    <Navigate to="/app" replace />
  );

export const profileSettingsRoutes = () => (
  <Route path="profile-settings" element={<ProfileSettings />}>
    <Route index element={<ProfileSettingsIndex />} />
    <Route path="security" element={<ChangePasswordGuard />} />
    <Route
      path="email-signature"
      element={
        <AccountFeatureGuard feature="ticketing">
          <RouteAnalytics pageName="Email-Signature">
            <EmailSignature />
          </RouteAnalytics>
        </AccountFeatureGuard>
      }
    />
    <Route
      path="slack-connection"
      element={
        <AccountFeatureGuard feature="ticketing">
          <RouteAnalytics pageName="Slack-Connection">
            <SlackConnection />
          </RouteAnalytics>
        </AccountFeatureGuard>
      }
    />
  </Route>
);
